/* src/app/shared/components/dual-range-slider/dual-range-slider.component.scss */
.range-slider {
  position: relative;
  padding-top: 0.75rem;
}
.range-slider .label {
  position: absolute;
  top: 1.5rem;
  width: auto;
  height: 1em;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  color: #5F5753;
}
.range-slider .label.min {
  left: 0;
}
.range-slider .label.max {
  right: 0;
}
input[type=range] {
  --thumb-size: 1.5rem;
  -webkit-appearance: none;
  appearance: none;
  height: 0.25rem;
  border-radius: 9999px;
  width: 100%;
  position: absolute;
  background-color: #C6C6C6;
  pointer-events: none;
}
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: var(--thumb-size);
  height: var(--thumb-size);
  background-color: #0A8080;
  border: solid 0.35rem white;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  position: relative;
}
input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: var(--thumb-size);
  height: var(--thumb-size);
  background-color: #0A8080;
  border: solid 0.35rem white;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  position: relative;
}
.slider.from {
  height: 0;
  z-index: 1;
}
:host(.dual-range-slider) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
}
/*# sourceMappingURL=dual-range-slider.component.css.map */
